<template>
  <div>
    <DataTablePartido
      :headers="headers"
      :path="path"
      :filterPath="filterPath"
      :properties="properties"
      action-buttons-name="InformeAuditoriaActionButton"
      filter
      toolbar
      :toolbar-title="toolbarTitle"
      :search-text="searchText"
      :category-id="$route.params.id"
    >
      <slot slot="toolbar-table"></slot>
    </DataTablePartido>
    <InformeAuditoriaCreatePopUpPartido
      v-if="canCreate"
      ref="creacionPopup"
    ></InformeAuditoriaCreatePopUpPartido>
    <v-btn
      v-if="canCreate"
      app
      dark
      fixed
      fab
      bottom
      right
      class="add-button"
      @click="newPresentacion"
    >
      <v-icon>add</v-icon>
    </v-btn>
  </div>
</template>

<script>
import DataTablePartido from '../../../common/ui/DataTablePartido'
import InformeAuditoriaCreatePopUpPartido from '../components/fields_components/InformeAuditoriaCreatePopUpPartido.vue'

export default {
  methods: {
    newPresentacion () {
      this.$refs.creacionPopup.showDialog()
    }
  },
  props: {
    actionButtonsName: {
      type: String,
      default: 'InformeAuditoriaActionButton'
    },
    path: {
      type: String,
      default: 'informe-auditoria-partido'
    },
    filterPath: {
      type: String,
      default: 'filters/Informes-auditorias-partido'
    },
    initialProperties: {
      type: Array,
      default: () => {
        return [
          'pk',
          'author',
          'createdAt',
          'reportDescription',
          'partidoDisplay',
          'reportType',
          'torneoDisplay',
          'fechaDisplay',
          // 'clubLocalDisplay',
          // 'clubVisitanteDisplay',
          'statusDisplay'
        ]
      }
    },
    initialHeaders: {
      type: Array,
      default: () => {
        return []
      }
    },
    toolbarTitle: {
      type: String,
      default: 'Informes por Partidos'
    },
    searchText: {
      type: String,
      default: 'Buscar por descripción o tipo'
    },
    mandatory: {
      type: Boolean,
      default: true
    }
  },

  components: {
    DataTablePartido,
    InformeAuditoriaCreatePopUpPartido
  },

  computed: {
    headers () {
      let headers = [
        { text: 'Codigo', align: 'left', value: 'pk', sortable: false },
        { text: 'Creador', value: 'author', sortable: false },
        { text: 'Creación', value: 'createdAt', sortable: true },
        { text: 'Informe', value: 'reportDescription', filterField: false },
        { text: 'Partido', value: 'partido', filterField: false },
        { text: 'Tipo', value: 'reportType', filterField: false },
        { text: 'Torneo', value: 'torneo', filterField: false },
        { text: 'Fecha', value: 'fecha', filterField: false },
        // { text: 'Local', value: 'club_local', filterField: false },
        // { text: 'Visitante', value: 'club_visitante', filterField: false },
        { text: 'Estado', value: 'status', filterField: false },
        { text: 'Acciones', align: 'right', sortable: false }
      ]
      return headers
    },
    properties () {
      let properties = this.initialProperties
      return properties
    },
    canCreate () {
      return this.$store.state.permissions.canAddInformesAuditorias
    }
  }
}
</script>
